import type { SectionTypeId } from "@noko-city/shared";

import { ContactSection } from "./contact";
import { ContentsSection } from "./contents";
import { CostSection } from "./cost";
import { EssentialsSection } from "./essentials";
import { ExperiencesSection } from "./experiences";
import { GoingOutSection } from "./going-out";
import { HistorySection } from "./history";
import { IdentitySection } from "./identity";
import { InstagramSection } from "./instagram";
import type { SectionRenderer } from "./types";
import { VenuesSection } from "./venues";

/**
 * One renderer per section type, and the only place a section type meets the
 * component that draws it: the registry says what a section is, this map says who
 * renders it, and the record is exhaustive over the ids so a new type cannot be
 * added without a renderer to draw it.
 */
export const SECTION_RENDERERS: Readonly<Record<SectionTypeId, SectionRenderer>> = {
  identity: IdentitySection,
  instagram: InstagramSection,
  contents: ContentsSection,
  history: HistorySection,
  experiences: ExperiencesSection,
  "going-out": GoingOutSection,
  essentials: EssentialsSection,
  cost: CostSection,
  venues: VenuesSection,
  contact: ContactSection,
};
